// extracted by mini-css-extract-plugin
export default {"infoPopup":"InfoModal_infoPopup__P2jIx","text":"InfoModal_text__IYzCP"};